// src/services/api/RootApiService.js
// Универсальный клиент для запросов к корню API (без resourcePath),
// сохраняет всю инфраструктуру BaseApi: токен, перехватчики и т.д.
import BaseApi from './BaseApi';

class RootApiService extends BaseApi {
  constructor() {
    // Пустой basePath → baseURL = VITE_API_BASE_URL (например, http://localhost:1337/api)
    super('');
  }

  async checkSlugAvailability(type, slug) {
    const response = await this.api.get('/slug-availability', {
      params: { type, slug },
      skipToken: true,
    });

    return response.data?.data?.available === true;
  }
}

export default new RootApiService();
